import { getDefaultCountryCode } from 'utilities/localization';

import { cartModel } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import initializePayPalButton from '../../initializePayPalButton';
import PayPalButtonTemplate from '../templates/PayPalButtonTemplate';

const PayPalButton = CartBaseItemView.extend({
	JSXTemplate: PayPalButtonTemplate,
	initialize () {

		this.listenTo(this.model, 'change', () => {

			this.render();

		});

	},
	templateHelpers () {

		const helpers = {
			paypalButtonId: this.options.paypalButtonId,
			shouldShowPayPalButton: this.shouldShowPayPalButton()
		};

		return helpers;

	},
	onRender () {

		if (!this.shouldShowPayPalButton()) {

			return;

		}

		initializePayPalButton({
			cartModel,
			label: this.options.paypalButtonId.replace('paypal', ''),
			buttonContainerElementSelector: `#${this.options.paypalButtonId}`,
			allowAdditionalPayPalPaymentMethods: this.options.allowAdditionalPayPalPaymentMethods,
			style: {
				color: window.lp.paypalButtonColor || 'white',
				height: 40,
				label: 'paypal',
				shape: 'rect',
				size: 'responsive'
			}
		});

	},
	shouldShowPayPalButton () {

		const { isCustomerService, isKiosk, isProfessional } = window.lp.globals;
		return window.paypal && !isCustomerService && !isKiosk && !isProfessional && this.model.get('PayPal').IsEnabled;

	}
});

export default PayPalButton;
